// extracted by mini-css-extract-plugin
module.exports = {"disabledInput":"GroupLevelAttributeNumberField_disabledInput_2IiDR"};